/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum AlertsColumnEnum {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    CREATED_BY = 'CREATED_BY',
    CREATED_ON = 'CREATED_ON',
    UPDATED_BY = 'UPDATED_BY',
    UPDATED_ON = 'UPDATED_ON',
    STARTS_ON = 'STARTS_ON',
    ENDS_ON = 'ENDS_ON',
    ACTIVE = 'ACTIVE',
}
